<template>
  <div style="clear: left;">
    <div style="text-align: left; margin-top: 20px;">
      <span style="background-color: #c5c3cd; font-weight: bold;">▬ ▬ ▬ ▬【{{ regionInfo.displayName }}】▬ ▬ ▬ ▬</span>
    </div>
    <template v-for="store in ['appStore', 'googlePlay']">
      <ranking :key="store" v-if="regionInfo[store]"  :ranking="regionInfo[store]" :regionKey="regionKey" :storeType="store" />
    </template>
  </div>
</template>

<script>
import Ranking from './Ranking.vue';

export default {
  name: 'Region',
  components: {
    Ranking,
  },
  props: ['regionInfo', 'regionKey'],

}
</script>

<style scoped>
</style>
